import type { StockVideoFile, StockVideoItem } from '@/rve/stockTypes';

/** Pick a Pexels rendition URL for RVE ``getVideoUrl``. */
export function pickPexelsVideoUrl(
  video: StockVideoItem,
  quality: StockVideoFile['quality'],
): string {
  const match = video.videoFiles.find((file) => file.quality === quality);
  return match?.url ?? video.videoFiles[0]?.url ?? video.thumbnail;
}
